<template>
    <transition name="ncbottom">
        <div class="nctouch-bottom-mask mask-show" v-show="show" ref="layer">
            <div class="nctouch-bottom-mask-bg" @click="bindHide()"></div>
            <div class="nctouch-bottom-mask-block">
                <div class="nctouch-bottom-mask-top">
                    <div class="close" @click="bindHide()"><i class="closed"></i>လိပ္စာ</div>
                </div>
                <div class="city-options">
                    <div class="city-content">
                        <dl class="city-select">
                            <dd v-for="(navItem ,navIndex)  in areaNavArray"
                                :class="{select:navIndex ==currentAreaIndex }"
                                @click="bindAreaNavSelect(navIndex)">{{navItem.areaName2}}
                            </dd>
                        </dl>
                        <div class="city-select-panel" ref='swipe'>
                            <ul :style="{width: width * areaContentArray.length + 'px'}">
                                <li v-for="(cItem , cIndex) in areaContentArray" :style="{width: width + 'px'}">
                                    <div class="city-item-scroll" :id="'cityItem_' + cIndex">
                                        <dl class="city-item">
                                            <a href="javascript:;"
                                               v-for="areaItem in  cItem"
                                               @click="bindAreaSelect(areaItem,cIndex)"
                                               :class="{checked:currentAreaInfo &&  currentAreaInfo.areaId==areaItem.areaId}">
                                                <h4>{{areaItem.areaName}}</h4><i></i></a>
                                        </dl>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    /**
     * 普通的地区选择
     */

    var mySwipe, myIScroll,
            iscrollArray = []
            ;
    export default {
        //外部传入参数
        props: {
            max: {
                type: Number,
                default: 3
            },

            show: {
                type: Boolean,
                required: true
            }
        },
        /*
         * 自身数据,一定要一个function
         */
        data() {
            return {
                urlAreaList: ApiUrl + '/area/list',
                currentAreaIndex: 0,
                areaNavArray: [{
                    areaName: "ေျရးခ္ယၸါ",//請選擇
                    areaName2:"တိုင္း",
                    areaId: 0
                }],
                //地区列表数组
                areaContentArray: [],

                showArea: false ,
                //标识是否正在发送请求
                isPosting  : false
            }
        },
        /**
         * 计算属性
         */
        computed: {
            width: function () {
                return $(window).width()
            },
            //当前地区选择信息
            currentAreaInfo: function () {
                return this.areaNavArray[this.currentAreaIndex]
            }
        },

        /**
         * 监听属性变动
         */
        watch: {
            show: function (value) {
                if (!value) return;
                this.initArea()
            }
        },

        /**
         * 自定义方法
         */
        methods: {

            //初始化地区
            initArea: function () {
                var self = this

                $.get(this.urlAreaList, {
                    areaId: 0
                }, function (xhr) {
                    var str = JSON.stringify(xhr);
                    var my = Rabbit.uni2zg(str);
                    xhr = JSON.parse(my);
                    if (xhr.code == 200) {
                        self.currentAreaIndex = 0;
                        self.areaNavArray.splice(0, self.areaNavArray.length, {
                            areaName2: "တိုင္း",//省
                            areaId: 0
                        });
                        self.areaContentArray.splice(0, self.areaContentArray.length, xhr.datas.areaList)
                        self.setupSwipe()
                        self.slideToSwipe(0)
                    }
                })
            },
            /**
             * 手动刷新swipe
             */

            setupSwipe: function () {
                var self = this
                this.$nextTick(function () {

                    var _currentIndex = self.currentAreaIndex > 0 ? self.currentAreaIndex - 1 : 0;
                    if (mySwipe) {
                        mySwipe.refresh()
                        return
                    }
                    mySwipe = new IScroll(this.$refs.swipe, {
                        scrollX: true,
                        scrollY: false,
                        momentum: false,
                        snap: true,
                        snapSpeed: 400,
                        click: false,
                        bounce: false,
                        excludeElement: "scroll-exclude",
                        snapCallBack: function (pageX, pageY) {

                            self.currentAreaIndex = pageX
                        }
                    });
                })
            },
            /**
             * 地区swipe滚动到
             * @param index
             * @param retain
             */
            slideToSwipe: function (index, retain) {
                this.$nextTick(function () {

                    mySwipe.goToPage(index, 0)

                    if (retain) return
                    if (iscrollArray[index]) {
                        iscrollArray[index].destroy();
                    }
                    iscrollArray[index] = new IScroll("#cityItem_" + index, {
                        scrollX: false,
                        scrollY: true,
                        click: true
                    });

                })
            },
            //获取地区列表
            loadAreaList: function (areaId) {
                var self = this;
                if (this.isPosting){
                   return
                }
                this.isPosting = true
                $.get(this.urlAreaList, {
                    areaId: areaId
                }, function (xhr) {
                    var str = JSON.stringify(xhr);
                    var my = Rabbit.uni2zg(str);
                    xhr = JSON.parse(my);
                    if (xhr.code == 200) {
                        // self.areaNavArray.push({
                        //     areaName: "ေျရးခ္ယၸါ",//請選擇
                        //     areaId: 0
                        // });
                        self.areaContentArray.push(xhr.datas.areaList)
                        self.setupSwipe()
                        self.slideToSwipe(self.currentAreaIndex)
                    } else {
                        //地区选择完成
                        self.areaSelectEnd();
                    }
                }).always(function () {
                    self.isPosting = false
                })
            },

            //地区选择结束
            areaSelectEnd: function () {
                var _areaIds = [],
                        _areaInfo = this.areaNavArray.map(function (value) {
                            _areaIds.push(value.areaId)
                            return value.areaName
                        }).join(" ");
                this.$emit('selectend', _areaInfo, _areaIds)
            },
            /**
             * 地区导航点击
             * @param navIndex
             */
            bindAreaNavSelect: function (navIndex) {
                this.currentAreaIndex = navIndex
                this.slideToSwipe(navIndex, true)
            },
            //地区列表中的地区选择
            bindAreaSelect: function (areaInfo, index) {
                if (this.currentAreaInfo && this.currentAreaInfo.areaId == areaInfo.areaId) return;
                this.currentAreaIndex = index + 1;
              if(this.currentAreaIndex==1){
                this.areaNavArray.splice(index, this.areaNavArray.length, {
                  areaName: areaInfo.areaName,
                  areaName2:"တိုင္း",
                  areaId: areaInfo.areaId
                })
                this.areaNavArray.push({
                  areaName2:"ခရိုင္"
                })
              }
              else if(this.currentAreaIndex==2){
                this.areaNavArray.splice(index, this.areaNavArray.length, {
                  areaName: areaInfo.areaName,
                  areaName2:"ခရိုင္",
                  areaId: areaInfo.areaId
                })
                this.areaNavArray.push({
                  areaName2:"ၿမိဳ႕နယ္"
                })
              }
              else if(this.currentAreaIndex==3){
                this.areaNavArray.splice(index, this.areaNavArray.length, {
                  areaName: areaInfo.areaName,
                  areaName2:"ၿမိဳ႕နယ္",
                  areaId: areaInfo.areaId
                })
                this.areaNavArray.push({
                  areaName2:"ၿမိဳ႕"
                })
              }
              else if(this.currentAreaIndex==4){
                this.areaNavArray.splice(index, this.areaNavArray.length, {
                  areaName: areaInfo.areaName,
                  areaName2:"ၿမိဳ႕",
                  areaId: areaInfo.areaId
                })

              }
                // this.areaNavArray.splice(index, this.areaNavArray.length, {
                //     areaName: areaInfo.areaName,
                //     areaId: areaInfo.areaId
                // })
                this.areaContentArray.splice(index + 1);
                console.log(this.max);
                if (this.areaContentArray.length >= this.max) {
                    this.areaSelectEnd();
                } else {
                    this.loadAreaList(areaInfo.areaId)
                }

            },
            bindHide: function () {
                this.$emit('hide')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/area-select-normal/area-select-normal.vue